import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRevert = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9663 9.1299L10.2373 14.9269L15.9293 13.3409",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9209 26.2C10.5122 25.6024 10.1636 24.966 9.8799 24.3",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.461 30.4119C15.9357 30.2326 15.4246 30.014 14.932 29.7579C14.7987 29.6913 14.668 29.6199 14.54 29.5439",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5385 30.41C22.869 30.6374 22.1791 30.8002 21.4785 30.896",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.0796 26.206C28.6594 26.8216 28.1775 27.3929 27.6416 27.911",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7588 14.027C12.1157 11.9268 14.1477 10.3515 16.5199 9.5609C18.892 8.7702 21.4627 8.8113 23.8084 9.6775C26.154 10.5436 28.1346 12.183 29.4237 14.3256C30.7127 16.4681 31.2334 18.9859 30.8998 21.464",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgArrowRevert);
export default ForwardRef;
